import { Route, Routes } from 'react-router-dom';

import { css } from '@emotion/react'
import styled from '@emotion/styled'

// basic routes
import VendorList from '../components/Vendors/VendorList';
import EditVendor from '../components/Vendors/EditVendor';
import ViewVendor from '../components/Vendors/ViewVendor';

const Vendors = () => {
  return (
    <Routes>
      <Route path="/" element={<VendorList />} />
      <Route path="/edit/:id" element={<EditVendor />} />
      <Route path="/edit" element={<EditVendor />} />
      <Route path="/view/:id" element={<ViewVendor />} />
    </Routes>
  )
}

export default Vendors;